import { render, staticRenderFns } from "./VendedorPanel.vue?vue&type=template&id=f3bfb742&scoped=true"
import script from "./VendedorPanel.vue?vue&type=script&lang=js"
export * from "./VendedorPanel.vue?vue&type=script&lang=js"
import style0 from "./VendedorPanel.vue?vue&type=style&index=0&id=f3bfb742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bfb742",
  null
  
)

export default component.exports